import { api } from "@/lib/api";

export interface InitiateUploadRequest {
  fileName: string;
  contentType: string;
  fileSize: number;
}

export interface InitiateUploadResponse {
  uploadId: string;
  key: string;
  partUrls: Array<{ partNumber: number; url: string }>;
  totalParts: number;
  type: "audio" | "video";
}

export interface UploadPart {
  PartNumber: number;
  ETag: string;
}

export interface CompleteUploadRequest {
  uploadId: string;
  key: string;
  parts: UploadPart[];
  title: string;
  description?: string;
  userId: string;
}

export interface CompleteUploadResponse {
  id: string;
  type: string;
  status: string;
  rawUrl: string;
  message: string;
}

export const contentService = {
  async initiateUpload(
    type: "audio" | "video",
    data: InitiateUploadRequest,
  ): Promise<InitiateUploadResponse> {
    return api.post<InitiateUploadResponse>(
      `/content/${type}/initiate-upload`,
      data,
    );
  },

  async completeUpload(
    type: "audio" | "video",
    data: CompleteUploadRequest,
  ): Promise<CompleteUploadResponse> {
    return api.post<CompleteUploadResponse>(
      `/content/${type}/complete-upload`,
      data,
    );
  },
};
